import React from "react";
import { FaEdit, FaTrash, FaRedo } from "react-icons/fa";

function UsersTable({ users, onEdit, onDelete, onReactivate }) {
    return (
        <table className="app-table">
            <thead>
            <tr>
                <th>Id</th>
                <th>Username</th>
                <th>Firstname</th>
                <th>Lastname</th>
                <th>Email Address</th>
                <th>Role</th>
                <th>Is Active</th>
            </tr>
            </thead>
            <tbody>
            {users.map(user => (
                <UserRow user={user} key={user.id} onEdit={onEdit} onDelete={onDelete} onReactivate={onReactivate}/>
            ))}
            </tbody>
        </table>
    );
}

function UserRow({ user, onEdit, onDelete, onReactivate }) {
    return (
        <tr>
            <td>{user.id}</td>
            <td>{user.username}</td>
            <td>{user.firstname}</td>
            <td>{user.lastname}</td>
            <td>{user.emailAddress}</td>
            <td>{user.roleName}</td>
            <td>{user.isActive ? 'Active' : 'Inactive'}</td>
            <td>
                {user.isActive && (
                    <FaEdit className="edit-icon" onClick={() => onEdit(user)}/>
                )}
            </td>
            <td>
                {user.isActive ? (
                    <FaTrash className="delete-icon" onClick={() => onDelete(user.id)}/>
                ) : (
                    <FaRedo className="reactivate-icon" onClick={() => onReactivate(user.id)}/>
                )}
            </td>
        </tr>
    );
}

export default UsersTable;
